// @flow
import React from 'react';

import { TrackingPageLoad } from 'Tracking/tracking-pageload/TrackingPageLoad.jsx';

import { Hero } from 'Components/widgets/hero/Hero.jsx';
import { TextLink } from 'Components/frameworks/text-link/TextLink.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { PAGE_404 } from 'Utils/request/requestDictionary';

type Props = {
  config: CMSContent,
};

const getInitialProps = async ({ appContext }: { appContext: AppContext }) => {
  const query = `query {
      config {
        errors { notFound { image title } }
        common { goToHome }
      }
    }`;
  return graphQLClient.runQuery(query, appContext, { requestName: PAGE_404 });
};

const NotFoundView = ({ config }: Props) => {
  return (
    <React.Fragment>
      <TrackingPageLoad pageName="Shopping_NotFound" siteSection="Shopping_NotFound" />
      <div className="NotFoundView">
        <Hero size="total" url={config?.errors?.notFound?.image} />
        <div className="NotFoundView-inner">
          <SiteContainer size="mini">
            <h1 className="NotFoundView-title font-brand">{config?.errors?.notFound?.title}</h1>
            <TextLink url="/" label={config?.common?.goToHome} theme="solid" />
          </SiteContainer>
        </div>
      </div>
    </React.Fragment>
  );
};

NotFoundView.getInitialProps = getInitialProps;

export default NotFoundView;
